// Query keys for React Query caching
export const subjectQueryKeys = {
  // Subject user-related keys
  subjectUsers: ['subject-users'] as const,
  subjectUsersBySubject: (tenantId: string, subjectId: string) =>
    [...subjectQueryKeys.subjectUsers, 'by-subject', tenantId, subjectId] as const,
  subjectUsersByRole: (tenantId: string, subjectId: string, role: string) =>
    [...subjectQueryKeys.subjectUsers, 'by-role', tenantId, subjectId, role] as const,

  // Subject info keys
  subjectInfo: ['subject-info'] as const,
  subjectById: (subjectId: string) => [...subjectQueryKeys.subjectInfo, subjectId] as const,

  // User existence check
  userExists: ['user-exists'] as const,
  userExistsByEmail: (email: string) => [...subjectQueryKeys.userExists, email] as const,
};
